import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { fmtError } from "@/lib/api";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await googleSession(sid);
        // Clear the hash so it doesn't re-fire
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/", { replace: true });
      } catch (err) {
        toast.error(fmtError(err));
        navigate("/login", { replace: true });
      }
    })();
  }, [googleSession, navigate]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="text-center space-y-3">
        <Loader2 className="h-6 w-6 animate-spin text-primary mx-auto" />
        <p className="text-sm text-muted-foreground">Signing you in…</p>
      </div>
    </div>
  );
}
